import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { API_URLS } from '../../../@shelter/utils/API_URLS';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';
@Component({
  selector: 'app-upload-excel',
  templateUrl: './upload-excel.component.html',
  styleUrls: ['./upload-excel.component.scss']
})
export class UploadExcelComponent implements OnInit {

  params: any;
  getLabelFunction: any;
id:any
  fileUploadForm: FormGroup;

  constructor(
    private _httpClient: HttpClient,
    private formBuilder: FormBuilder
  ) { }

  agInit(params: any): void {
      this.params = params;
      this.getLabelFunction = this.params.getLabelFunction;
  
  }


  refresh(params?: any): boolean {
      return true;
  }
  isPopup(): boolean {
      return false;
  }
  // onClick($event:any) {
  //     if (this.params.onClick instanceof Function) {
  //         const params = {
  //             event: $event,
  //             rowData: this.params.node,
  //         };
  //         this.params.onClick(params);   
  //         console.log(params); 
              
  //     }
     
      
  // }
 
  ngOnInit(): void {
    this.fileUploadForm = this.formBuilder.group({
      myfile: ['']
    });
  
    
  }

  onFileSelect(event:any) {
   this.id=this.params.value
   console.log("id",this.id);
   
    let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
       console.log(file);

      if (!_.includes(af, file.type)) {
        alert('Only EXCEL Docs Allowed!');
      } else {

        this.fileUploadForm.get('myfile').setValue(file);
        
      }
      if (!this.fileUploadForm.get('myfile').value) {
        alert('Please fill valid details!');
        return false;
      }
      const formData = new FormData();
      formData.append('file', this.fileUploadForm.get('myfile').value);
       this._httpClient.post(API_URLS.Occasion.uploadExcel.replace('{occasionId}',this.id),formData).subscribe(res=>{
      console.log(res);
      
    })
     
    }
  }
  onFormSubmit() {

//     if (!this.fileUploadForm.get('myfile').value) {
//       alert('Please fill valid details!');
//       return false;
//     }
//  console.log(this.fileUploadForm.get('myfile').value);
 
//     const formData = new FormData();
//     formData.append('formFile', this.fileUploadForm.get('myfile').value);
// 
    // this._httpClient.put(API_URLS.Occasion.uploadExcel.replace('{id}',''),formData).subscribe(res=>{
    //   console.log(res);
      
    // })
    
  }
 

}
